/**
 * 팝업 기반 Google 로그인 — 메인창 ↔ 팝업 간 메시지 프로토콜 및 팝업 제어.
 * React에 의존하지 않는 순수 유틸 (훅/컴포넌트가 가져다 쓴다).
 */

export type AuthMessage =
  | { type: "auth-success" }
  | { type: "auth-error"; message: string };

/** 콜백 페이지가 팝업 창 안에서 열렸는지 (LoginPage가 window.open으로 띄운 경우) */
export function isOpenedAsPopup(): boolean {
  return !!window.opener && window.opener !== window;
}

/** 콜백(팝업) → 메인창으로 결과 전송 후 팝업 닫기. 같은 출처로만 전송. */
export function postAuthResult(message: AuthMessage): void {
  window.opener?.postMessage(message, window.location.origin);
  window.close();
}

/** 화면 중앙에 팝업 오픈. 브라우저가 차단하면 null 반환. */
export function openCenteredPopup(
  url: string,
  name: string,
  width: number,
  height: number
): Window | null {
  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;
  return window.open(
    url,
    name,
    `width=${width},height=${height},left=${left},top=${top},menubar=no,toolbar=no,location=no,status=no`
  );
}
